import * as React from "react";
import { AbstractProduct } from '../AbstractProducts/AbstractProduct'
import PublishIcon from "../../../../../assets/icons/publishnews.svg";

// tslint:disable-next-line:no-empty-interface
export interface IPublishNewsPanelProductProps {}

export class PublishNewsPanelProduct extends React.Component<IPublishNewsPanelProductProps, any> {
  public render() {
    return (
      <AbstractProduct 
        img={PublishIcon}
        name="Mais vendidos Publish News"
        url="/panel/publish-news" />
    );
  }
}


// WEBPACK FOOTER //
// ./src/component/shared/layout/products/InitializedProducts/PublishNewsPanelProduct.tsx